import ApiIntegrationRequest from "../../api-request/api-intergration";

export default class ApiIntegrationGithub {

    constructor() {}

    static moduleStatus() {
        return ApiIntegrationRequest.GET(this, 'github/module-status')
    }

    static disableRepository(repository:any) {
        return ApiIntegrationRequest.DELETE(this,'github/repository/'+repository.id)
    }

    static enableRepository(repository:any) {
        return ApiIntegrationRequest.POST(this, 'github/repositories', {
            repositoryId        : repository.id,
            repositoryName      : repository.name,
            repositoryOwner     : repository.owner
        })
    }


    static getRepositories() {
        return ApiIntegrationRequest.GET(this, 'github/repositories');
    }

    static getBranches(repositoryId:ID) {
        return ApiIntegrationRequest.POST(this, 'github/branches', {
            repositoryId    : repositoryId
        })
    }

    static getCommits(branchId:ID) {
        return ApiIntegrationRequest.GET(this, 'github/commits',{
            branchId: branchId
        });
    }

    static disableIntegration() {
        return ApiIntegrationRequest.DELETE(this, 'github/module-status');
    }



}
